import { gql } from '@apollo/client';

export const GET_USER_DATA = gql`
  query ClientQuery {
    user {
      address
      size
      city
      country
      createdAt
      zipCode
      streetNumber
      suiteOrApt
      streetName
      notification
      email
      firstName
      id
      isPhoneVerified
      lastName
      name
      state
      photo
      phone
      businessForm
      banner {
        image
        video
        btnLabel
        btnUrl
        title
        description
      }
      updatedAt
    }
  }
`;
